import React from "react";
import { MemoryRouter, Route, Routes, useLocation } from "react-router-dom";

import RouteTabs from "./RouteTabs";

const Panel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="rounded-md border border-gray-200 p-4 text-sm text-gray-700">{children}</div>
);

/** Tiny readout so you can see the URL change as you click tabs. */
const CurrentPath: React.FC = () => {
	const { pathname } = useLocation();
	return (
		<p className="text-xs text-gray-500">
			Current route: <code>{pathname}</code>
		</p>
	);
};

const Inner: React.FC = () => (
	<div className="space-y-3">
		<CurrentPath />
		<RouteTabs
			skipTranslation
			rightSlot={
				<button className="rounded-md border border-gray-200 px-3 py-1.5 text-sm font-medium text-gray-600 hover:bg-gray-50">
					MORE
				</button>
			}
			tabs={[
				{ route: "profile", label: "Profile", content: <Panel>Customer profile</Panel> },
				{ route: "jobs", label: "Jobs", content: <Panel>Customer jobs</Panel> },
				{
					route: "invoice-details",
					label: "Invoice details",
					content: <Panel>Invoice details</Panel>,
				},
				{
					route: "contract-and-prices",
					label: "Contract & prices",
					content: <Panel>Contract & prices</Panel>,
				},
				{ route: "users", label: "Users", content: <Panel>Customer users</Panel> },
			]}
		/>
	</div>
);

/**
 * Example for the route-aware {@link RouteTabs} wrapper. It is rendered inside a
 * {@link MemoryRouter} so navigation stays contained within the showcase rather
 * than changing the real app URL. Click between tabs and watch the route update
 * — this is the deep-linkable, back/forward-friendly behaviour used for
 * customer/consultant/job detail sub-pages.
 */
const RouteTabsExample: React.FC = () => {
	return (
		<div className="max-w-2xl space-y-4 p-6">
			<div>
				<h2 className="mb-2 text-xl font-bold">RouteTabs (route-aware)</h2>
				<p className="text-sm text-gray-600">
					Built on the shadcn <code>Tabs</code> primitive but driven by the URL — the modern
					replacement for the legacy <code>Shared/Tabs/TabGroup</code>. The active tab is derived
					from the path and selecting a tab navigates.
				</p>
			</div>

			<MemoryRouter initialEntries={["/profile"]}>
				{/* The bare "*" route keeps the page mounted across every sub-path. */}
				<Routes>
					<Route path="/*" element={<Inner />} />
				</Routes>
			</MemoryRouter>
		</div>
	);
};

export default RouteTabsExample;
